import { httpGet, httpPost } from '@/request/'
import { REDIRECT } from '@/configs/configs'

//微信授权
function webchatAuth(returnUrl) {
  let tempauthh = 'http://wx.abcvote.cn/actives/courses/'
  if (window.location.protocol === 'https:') {
    tempauthh = 'https://wx.abcvote.cn/actives/courses/'
  }
  returnUrl = returnUrl || tempauthh
  REDIRECT && (location.href = REDIRECT + `&state=${returnUrl}#wechat_redirect`)
}

export { webchatAuth }
